<template>
  <form-accordion :title="pageTitle" :isTitleUpperCase="false">
    <b-row class="form-group">
      <b-col cols="6">
        <label>{{ $t('common.global.client') }}</label>
          <b-form-checkbox-group
            id="checkbox-group-1"
            :disabled="readonly"
            v-model="selectedVerif"
            :options="listVerifClientSSL"
            stacked
          ></b-form-checkbox-group>
      </b-col>
      <b-col cols="6">
        <label>{{ $t('common.global.server') }}</label>
        <b-form-checkbox-group
            id="checkbox-group-2"
            :disabled="readonly"
            v-model="selectedVerif"
            :options="listVerifServerSSL"
            stacked
          ></b-form-checkbox-group>
      </b-col>
    </b-row> 
  </form-accordion>
</template>
<script>
import FormAccordion from '@/components/common/FormAccordion.vue'

export default {
  name: 'LevelControlForm',
  components: {
    'form-accordion': FormAccordion
  },
  props: {
    placementLevel: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    selectedVerif:{
      get () {
        return this.inputValue.selectedVerif
      },
      set (val) {
        this.inputValue = {
          selectedVerif: val,
        }
      }
    },
    pageTitle () {
      return this.$i18n.t('common.global.ctrl_level') + (this.placementLevel + 1 > 0 ? (' ' + (this.placementLevel)) : '')
    },
  },
  data () { 
    return {
      listVerifClientSSL: [],
      listVerifServerSSL: [],
      verifChecked: ''     
    }
  },
  created () {
    this.formType = this.mode
    this.listVerifClientSSL = [
      {
        id: 1,
        text: this.$i18n.t('common.global.verify_peer'),
        value: '1'
      },
      {
        id: 2,
        text: this.$i18n.t('common.global.ctrl_CRL'),
        value: '2'
      },
      {
        id: 3,
        text: this.$i18n.t('common.global.ctrl_key_usage'),
        value: '3'
      },
      {
        id: 4,
        text: this.$i18n.t('common.global.ctrl_key_size'),
        value: '4'
      },
      {
        id: 5,
        text: this.$i18n.t('common.global.ctrl_expiration'),
        value: '5'
      },
      {
        id: 6,
        text: this.$i18n.t('common.global.ctrl_CN'),
        value: '6'
      },
    ]
    this.listVerifServerSSL = [
      {
        id: 1,
        text: this.$i18n.t('common.global.ctrl_CA'),
        value: '7'
      },
      {
        id: 2,
        text: this.$i18n.t('common.global.ctrl_CRL'),
        value: '8'
      },
      {
        id: 3,
        text: this.$i18n.t('common.global.ctrl_key_usage'),
        value: '9'
      },
      {
        id: 4,
        text: this.$i18n.t('common.global.ctrl_key_size'),
        value: '10'
      },
      {
        id: 5,
        text: this.$i18n.t('common.global.ctrl_expiration'),
        value: '11'
      }
    ]
  },
  methods: {
  },
  watch: {
  }
}
</script>